import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function writeOffInvoice(invoiceNo: string) {
  const res = await fetchOrchidAPI(`/api/invoicing/write_off/${invoiceNo}`, {
    method: "POST",
  });
  if (!res.ok) {
    throw new Error(
      `failed to write off invoice: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
